import { render, staticRenderFns } from "./CopayDepositPanel.vue?vue&type=template&id=723bbd7a&scoped=true&"
import script from "./CopayDepositPanel.vue?vue&type=script&lang=js&"
export * from "./CopayDepositPanel.vue?vue&type=script&lang=js&"
import style0 from "./CopayDepositPanel.vue?vue&type=style&index=0&id=723bbd7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723bbd7a",
  null
  
)

export default component.exports